import { render } from "./ChatItemView.vue?vue&type=template&id=8ebdbf02"
import script from "./ChatItemView.vue?vue&type=script&lang=js"
export * from "./ChatItemView.vue?vue&type=script&lang=js"
script.render = render

export default script